export default __webpack_public_path__ + "static/media/indihome.54164bcb.png";